
import request from '@/utils/request_common'

export const gearDatasApi = (year: string) =>
  request({
    url: `/issue/summary/gearDatas?year=${year}`,
    method: 'post',
  })

export const gearStudentCountDatasApi = (params: {endDate: string, startDate: string}) =>
  request({
    url: `/issue/summary/gearStudentCountDatas`,
    method: 'post',
    params
  })

export const getGearStuApplyListByStuApi = (data: any) =>
  request({
    url: `/issue/student/getGearStuApplyListByStu`,
    method: 'post',
    data
  })
// 导出学生查询列表
export const exportGearStuApplyListByStuExcelApi = (data: any) =>
  request({
    url: `/issue/student/exportGearStuApplyListByStuExcel`,
    method: 'post',
    data,
    responseType: "blob"
  });
// 学生查询 - 导出列表是否有数据
export const getIsGearStuApplyListByStuExcelApi = (data: any) =>
  request({
    url: `/issue/student/getIsGearStuApplyListByStuExcel`,
    method: 'post',
    data
  })

// gear学生入学申请页全部表单回显
export const getGearStudentApplyApi = (params: { fkStudentId: string, stuSource: string }) =>
  request({
    url: `/issue/student/getGearStudentApply`,
    method: 'get',
    params
  })

// gear学生指定入学申请页表单回显
export const getGearStudentApplyDetailApi = (params: { itemId: number, fkStudentId: string, stuSource: string }) =>
  request({
    url: `/issue/student/getGearStudentApplyDetail`,
    method: 'get',
    params
  })

// 申请状态列表
export const getGearStepListApi = () =>
  request({
    url: `/issue/student/getGearStepList`,
    method: 'get',
  })

// gear学生申请列表-按申请计划统计
export const getGearStuApplyListByOfferItemApi = (data: any) =>
request({
  url: `/issue/student/getGearStuApplyListByOfferItem`,
  method: 'post',
  data
})

// 导出申请计划列表
export const exportGearStuApplyListByOfferItemExcelApi = (data: any) =>
  request({
    url: `/issue/student/exportGearStuApplyListByOfferItemExcel`,
    method: 'post',
    data,
    responseType: "blob"
  });

// 申请计划 - 导出列表是否有数据
export const getIsGearStuApplyListByOfferItemExcelApi = (data: any) =>
  request({
    url: `/issue/student/getIsGearStuApplyListByOfferItemExcel`,
    method: 'post',
    data
  })

export const getCountryToIssueApi = () =>
  request({
    url: "/appInstitution/areaCountry/getCountryToIssue",
    method: "get",
  });
// 学校
export const getInstitutionDataApi = (countryId: number, selectStatus=2, issueSelectStatus = 0) => request({
  url: '/appInstitution/institution/getInstitutionDataToIssue',
  method: "get",
  params: { countryId, selectStatus, issueSelectStatus }
})

// 等级
export const getIssueMajorLevelListApi = () =>
  request({
    url: "/appInstitution/majorLevel/getIssueMajorLevelList ",
    method: "get"
  });

// 课程
export const getCourseToIssueApi = (fkInstitutionId: number | string, fkMajorLevelId: number | string) =>
  request({
    url: "/appInstitution/getCourses/getCourseToIssue",
    method: "get",
    params: { fk_institution_id: fkInstitutionId, fkMajorLevelId },
  });
// 获取首页统计数据所有年份
export const getAllYearsApi = () =>
  request({
    url: "/issue/summary/getAllYears",
    method: "get",
  });

export const gearApplyOverviewDatasApi = (year: string) =>
  request({
    url: `/issue/summary/gearApplyOverviewDatas`,
    method: 'post',
    params: { year }
  })

export const gearApplyAnalysisDatasApi = (year: string) =>
  request({
    url: `/issue/summary/gearApplyAnalysisDatas`,
    method: 'post',
    params: { year }
  })

// gear综合搜索
export const gearApplySearchApi = (keyword: string) =>
  request({
    url: `/issue/summary/gearApplySearch`,
    method: 'post',
    params: { keyword }
  })

/* 文件上传 formdata
* files: (binary)
* type: 'ISSUE-CENTER'
* stuId:
* typeKey: 'CV' | 'PASSPORT' | 'IELTS_TOEFL' | 'INTERNSHIP_CERTIFICATE' | 'CAS_BRP' | 'OTHERS' | 'AUTHORIZATION_LETTER' | 'DSE_TRANSCRIPT' | 'PS'
* oldFkGuId: （重新上传需要传）
* PS类型需要多传递参数：
*   fkInstitutionCourseName:
*   fkInstitutionName:
*   fkInstitutionShortName:
*   fkCourseId:
*
* const formdata = new FormData();
* formdata.append('files', file);
**/
export const uploadFileApi = (data: any) =>
  request({
    url: "/appFile/uploadStudent",
    method: "post",
    data,
  })

/* 单个文件下载
*  fileKey:
*  fileNameOrc:
*  filePath
**/
export const downLoadStuFileApi = (data: any) =>
  request({
    url: "/appFile/downloadIssue",
    method: "post",
    data,
    responseType: "blob"
  })
export const downLoadFileApi = (data: any) =>
  request({
    url: "/appFile/download",
    method: "post",
    data,
    responseType: "blob"
  })

// 删除文件
export const deleteFileApi = (fkGuId: string) =>
  request({
    url: "/issue/student/deleteFile",
    method: "post",
    params: { fkGuId },
  });

// 教育背景成绩类别下拉
export const getScoreTypeApi = () =>
  request({
  url: "/issue/studentEducatio/getScoreTypeEum",
  method: "get",
})
// 称谓
export const getIssueTitleApi = () =>
  request({
    url: "/issue/studentReference/getIssueTitle",
    method: "get",
  });

// gear附件文件上传回显
export const getGearStudentApplyFileListApi = (params: { fkStudentId: number | string, stuSource: string }) =>
  request({
    url: "/issue/student/getGearStudentApplyFileList",
    method: "get",
    params
  });

/** 财务结算 */
// 未结算
export const unsettledCommissionApi = () =>
  request({
    url: "/sale/commission/unsettledCommission",
    method: "get",
  });

// 已结算
export const inSettlementApi = () =>
  request({
    url: "/sale/commission/inSettlement",
    method: "get",
})
// 已收款
export const receivedPaymentApi = (params: any) =>
  request({
    url: "/sale/commission/receivedPayment",
    method: "get",
    params
})
// 代理账户列表
export const getAgentContractAccountApi = () =>
  request({
    url: "/sale/commission/getAgentContractAccount",
    method: "get",
})

// 保存附件
export const addCommissionFileApi = (data: { fkFileGuid: string, fkTypeKey: string, optGuid: string }) =>
  request({
    url: "/sale/commission/addCommissionFile",
    method: "post",
    data
})
// 差异提交
export const differentialSubmissionApi = (data: any) =>
  request({
    url: "/sale/commission/differentialSubmission",
    method: "post",
    data
})
// 提交条件检测
export const checkSubmissionApi = () =>
  request({
    url: "/sale/commission/checkSubmission",
    method: "get",
})
// 提交结算
export const submitSettlementApi = (data: any) =>
  request({
    url: "/sale/commission/onlySubmitSettlement",
    // url: "/sale/commission/submitSettlement",// 提交并下载文件
    method: "post",
    data,
    // responseType: "blob"
  })
// 总佣金
export const totalCommissionApi = () =>
  request({
    url: "/sale/commission/totalCommission",
    method: "get",
  })

export const getAgentUserInfoByIdApi = (onlineAgentUserId: number | string) =>
  request({
    url: "/appUser/getAgentUserInfoById",
    method: "get",
    params: { onlineAgentUserId }
  })

// 公司Logo上传
// * const formdata = new FormData();
// * formdata.append('files', file);
export const uploadLogolIconUrlApi = (data: any) =>
  request({
    url: "/sale/agent/uploadLogolIconUrl",
    method: "post",
    data
})
// 获取公司logo
export const getAgentLogolIconUrlApi = () =>
  request({
    url: "/sale/agent/getAgentLogolIconUrl",
    method: "get",
})
// 获取登录用户所属快捷入口菜单(无需传参)
export const getGearShortcutMenuListApi = () =>
  request({
    url: "/issue/permission/getGearShortcutMenuList",
    method: "get",
})
// 记录用户进入菜单（用以记录用户菜单喜好来构成快捷入口）
export const addGearUserShortcutMenuApi = (data: any) =>
  request({
    url: "/issue/permission/addGearUserShortcutMenu",
    method: "post",
    data
})

// BD的联系方式和email
export const getAgentBdContactInfoApi = () =>
  request({
    url: "/sale/staffBdCode/getAgentBdContactInfo",
    method: "get",
  })

// 查看当月结算状态
// 0 未结算  1 结算中  2 已结算
export const getSubmissionStatusApi = () =>
  request({
    url: "/sale/commission/getSubmissionStatus",
    method: "get",
  })

// 获取结算中总佣金
export const totalInSettlementCommissionApi = () =>
  request({
    url: "/sale/commission/totalInSettlementCommission",
    method: "get",
  })

// 检查录入的学生邮箱
export const getRepeatedEmailApi = (params: any) =>
  request({
    url: "/issue/student/getRepeatedEmail",
    method: "get",
    params,
  })
// 下载打包全部文件
export const downLoadAllFileApi = (fkStudentId: any) =>
  request({
    url: '/appFile/issueDownloadList',
    method: 'post',
    params: { fkStudentId },
    responseType: 'blob',
  });
// 获取代理凭证信息
export const getAgentSettlementCredentialsApi = () =>
  request({
    url: "/sale/agentSettlementCredentials/info",
    method: "get",
  })

// 上传凭证附件
// * const formdata = new FormData();
// * formdata.append('files', file);
export const uploadAttachedApi = (data: any) =>
  request({
    url: "/sale/agentSettlementCredentials/uploadCredentials",
    method: "post",
    data
})
// 删除凭证
export const deleteSettlementCredentialsApi = (fileType: number) =>
  request({
    url: "/sale/agentSettlementCredentials",
    method: "delete",
    params: { fileType }
})
// 预览对账单
export const previewSettlementApi = (data: any) =>
  request({
    url: "/sale/commission/previewSettlement",
    method: "post",
    data,
    responseType: "blob"
  })
// 确认结算
export const confirmSettlementApi = (data: any) =>
  request({
    url: "/sale/commission/confirmSettlement",
    method: "post",
    data
})
// 获取新闻的系统更新内容
export function getNewsByTypeNameApi(){
  return request({
    url:'/appInstitution/news/getNewsByTypeName',
    method:'get',
    params:{typeName:'Admin >> GEAR上线提醒'}
  })
}
// 获取佣金结算时间配置
export const getBmsConfigByKeyApi = () => {
  return request({
    url:`/appSystem/config/getBmsConfigByKey/COMMISSION_SETTLEMENT_CONFIG`,
    method: 'get',
  })
}

// go pro积分
export const getPersonalAgentAcKpiSourceApi = () => {
  return request({
    url:`/sale/agentPointsManagement/getPersonalAgentAcKpiSource`,
    method: 'get',
  })
}
// 查看还有多少申请没submit
export const countStudentDraftApi = () => {
  return request({
    url:`/issue/analysis/countStudentDraft`,
    method: 'post',
  })
}